<template>
  <div
    class="my-10 flex h-screen items-center bg-white py-5 md:my-0 md:h-auto md:py-0 dark:bg-slate-700 dark:text-white"
  >
    <div
      class="mx-auto my-auto w-full rounded-md border border-gray-200 bg-white px-5 py-8 shadow-md sm:w-3/4 sm:px-8 lg:w-3/4 xl:ml-20 xl:w-3/4 xl:border-0 xl:bg-transparent xl:p-3 xl:shadow-none dark:rounded-md dark:border dark:border-white dark:bg-slate-800 dark:text-white"
    >
      <h2 class="text-center text-2xl font-bold capitalize-first xl:text-3xl">
        {{ $t('navigation.login_title') }}
      </h2>

      <div
        v-if="requestFailed"
        class="mt-4 rounded-sm bg-rose-200 p-3 text-rose-900 capitalize-first"
      >
        {{ $t('validation.auth_failed') }}
      </div>

      <form @submit.prevent="submitForm">
        <div class="mt-8 space-y-8">
          <div>
            <input
              v-model.trim="user_name"
              type="text"
              name="username"
              autocomplete="username"
              class="block w-full rounded-sm border px-4 py-3 focus:ring-1 focus:ring-primary-300 focus:outline-none"
              :placeholder="$t('global.username')"
              required
            />
            <div
              v-for="(error, index) in errors?.user_name ?? []"
              :key="index"
              class="form-help text-red-600"
            >
              {{ $t(error, { attribute: $t('attributes.user_name') }) }}
            </div>
          </div>

          <div>
            <div class="relative">
              <input
                v-model.trim="password"
                :type="passwordShowType"
                name="password"
                autocomplete="current-password"
                class="block w-full rounded-sm border px-4 py-3 focus:ring-1 focus:ring-primary-300 focus:outline-none"
                :placeholder="$t('attributes.password')"
                required
              />
              <div class="absolute inset-y-0 right-0 mr-4 flex items-center">
                <FontAwesomeIcon
                  class="cursor-pointer text-gray-500"
                  :icon="['fal', 'eye']"
                  size="lg"
                  @click="switchPasswordVisibility"
                />
              </div>
            </div>
            <div
              v-if="errors?.password"
              class="form-help text-red-600 capitalize-first"
            >
              {{ $t('validation.wrong_password') }}
            </div>
          </div>
        </div>

        <div
          class="mt-4 flex text-xs text-gray-700 sm:text-sm dark:text-gray-300"
        >
          <label
            class="mr-auto flex cursor-pointer flex-row items-center gap-2 capitalize-first select-none"
          >
            <input
              v-model="remember_me"
              type="checkbox"
              class="form-check-input rounded-sm border"
            />
            <span>{{ $t('attributes.remember_me') }}</span>
          </label>
        </div>

        <div class="mt-5 text-center xl:mt-8 xl:text-left">
          <button
            type="submit"
            class="btn w-full bg-primary-500 px-4 py-3 align-top text-white xl:mr-3 xl:w-32 dark:border dark:border-primary-500 dark:bg-slate-800 dark:text-primary-500 dark:hover:bg-slate-700"
          >
            <span class="capitalize-first">{{ $t('button.login') }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'LoginForm',
  components: { FontAwesomeIcon },
  data() {
    return {
      user_name: null,
      password: null,
      remember_me: false,
      passwordShowType: 'password',
      requestFailed: false
    }
  },
  computed: {
    ...mapGetters({ errors: 'auth/getErrors' })
  },
  methods: {
    ...mapActions({ login: 'auth/login' }),
    submitForm() {
      this.requestFailed = false
      this.login({
        auth_form: {
          user_name: this.user_name,
          password: this.password,
          remember_me: this.remember_me ? 'on' : undefined
        }
      })
        .then((authenticated) => {
          if (authenticated) {
            this.$router.push({ name: 'work_progress_route' })
          } else {
            this.requestFailed = true
          }
        })
        .catch(() => {
          this.requestFailed = true
        })
    },
    switchPasswordVisibility() {
      this.passwordShowType =
        this.passwordShowType === 'password' ? 'text' : 'password'
    }
  }
}
</script>
